import { render } from "./Ads.vue?vue&type=template&id=e818fbf8&scoped=true"
import script from "./Ads.vue?vue&type=script&lang=js"
export * from "./Ads.vue?vue&type=script&lang=js"

import "./Ads.vue?vue&type=style&index=0&id=e818fbf8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e818fbf8"]])

export default __exports__